"use client";

import { useProjectFilterTags } from "../hooks/useProjectFilterTags";
import { FilterTags } from "./filterTags";

export function ProjectFilterTags() {
  const { tags, reset } = useProjectFilterTags();
  return <FilterTags tags={tags} onReset={reset} />;
}
